<template>
  <v-card>
    <v-card-title class="project white--text">
      <div class="headline">Project Details</div>
    </v-card-title>
    <v-card-text>
      <v-layout row>
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Project ID
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.id }}
          </v-subheader>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Project Type
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.project_type_name }}
          </v-subheader>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Project Language
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ getProjectLanguage(ProjectData.project_language) }}
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout
        row
        v-if="
          ProjectData.project_language == 1 || ProjectData.project_language == 3
        "
      >
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Project Title English
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.name }}
          </v-subheader>
        </v-flex>
      </v-layout>
      <v-layout
        row
        v-if="
          ProjectData.project_language == 2 || ProjectData.project_language == 3
        "
      >
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Project Title Bangla
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.name_bangla }}
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex
          xs4
          v-if="
            ProjectData.project_language == 1 ||
            ProjectData.project_language == 3
          "
        >
          <v-subheader class="black--text font-weight-regular">
            Project Description Bangla
          </v-subheader>
        </v-flex>
        <v-flex xs8 class="ml-4">
          <tr>
            <td class="black--text font-weight-regular">
              {{ ProjectData.details }}
            </td>
          </tr>
        </v-flex>
      </v-layout>
      <v-layout
        row
        v-if="
          ProjectData.project_language == 2 || ProjectData.project_language == 3
        "
      >
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Project Description Bangla
          </v-subheader>
        </v-flex>
        <v-flex xs8 class="ml-4">
          <tr>
            <td class="black--text font-weight-regular">
              {{ ProjectData.details_bangla }}
            </td>
          </tr>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Project Submitted By
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.created_by }}
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Project Submission Date
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.created_at }}
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Estimated Starting Time
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.begin_date }}
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Estimated Ending Time
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.end_date }}
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout row v-if="ProjectData.project_type_id == 2">
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Visual Radius
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.visual_radius_km }} Km
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout row v-if="ProjectData.project_type_id == 2">
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Acceptable Radius
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.acceptance_radius_m }} Meter
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Minimum Survey Cost
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.min_price }} Tk.
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Project Total Budget
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.total_budget_amount }} Tk.
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout row v-if="checkStatus(ProjectData.project_type_id)">
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Total Coins
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.total_budget_coins }}
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Per Survey Cost
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.per_survey_cost }} Tk.
          </v-subheader>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs4>
          <v-subheader class="black--text font-weight-regular">
            Total Response
          </v-subheader>
        </v-flex>
        <v-flex xs8>
          <v-subheader class="black--text font-weight-regular">
            {{ ProjectData.number_of_response }}
          </v-subheader>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      ProjectData: {},
    },

    computed: {
      ...mapGetters(["indexData", "error", "statusCode", "errorMsg"]),
      isLoaded() {
        if (this.indexData.dataStatus8) {
          return true;
        } else {
          return false;
        }
      },
    },

    // created () {
    //   this.initialize('indexData.dataStatus8')
    // },

    methods: {
      initialize() {},
      parseDataToJson(value) {
        if (value != undefined) {
          return JSON.parse(value);
        }
        return "";
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },
      checkStatus(project_type_id) {
        //
        if (parseInt(project_type_id) > 7) {
          return true;
        } else {
          return false;
        }
      },
      getProjectLanguage(project_language) {
        if (project_language == 1) {
          return "English";
        } else if (project_language == 2) {
          return "Bangla";
        } else {
          return "English & Bangla both";
        }
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem
  .imageResize
    width: auto
    height: auto
  .project {
    background: #ff2e2e;
  }
</style>
